// extracted by mini-css-extract-plugin
module.exports = {"ul":"Pagination_ul__CaCCg","li":"Pagination_li__cgf8y","button":"Pagination_button__SJ3_Y"};